import React from 'react';
import PropTypes from 'prop-types';
import { ContentComponent, ContentComponents } from '@fogia/core-web/libs/sanity/utils/cmsComponentHandlers';

// Map of avaliable cmsModules and cmsLayouts.
const availableContent = {};

try {
    const themeModules = require('libs/sanity/content/Modules').default;
    for (const i in themeModules) {
        const currentView = themeModules[i];
        if (availableContent[i] === undefined) {
            availableContent[i] = currentView;
        }
    }
} catch (e) {
    console.error(e);
}

const CmsModules = ({ data, eagerImageModuleCount = 0, ...rest }) => {
    if (Array.isArray(data)) {
        return (
            <ContentComponents
                data={data}
                availableContent={availableContent}
                eagerImageModuleCount={eagerImageModuleCount}
                {...rest}
            />
        );
    }

    const imageLoading = eagerImageModuleCount > 0 ? 'eager' : 'lazy';

    return <ContentComponent data={data} availableContent={availableContent} imageLoading={imageLoading} {...rest} />;
};

CmsModules.propTypes = {
    data: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.object), PropTypes.object]),
    eagerImageModuleCount: PropTypes.number,
};

CmsModules.defaultProps = {
    data: {},
    eagerImageModuleCount: 0,
};

export default CmsModules;
